import { StatsCards } from "@/components/analytics/stats-cards";
import { ChartLicitacionesMes } from "@/components/analytics/chart-licitaciones-mes";
import { ChartEstadoPie } from "@/components/analytics/chart-estado-pie";
import { ChartTasaExito } from "@/components/analytics/chart-tasa-exito";
import { UpcomingDeadlines } from "@/components/analytics/upcoming-deadlines";

export default function AnalyticsPage() {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>

      <StatsCards />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Licitaciones por mes</h2>
          <ChartLicitacionesMes />
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Distribución por estado</h2>
          <ChartEstadoPie />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Tasa de éxito</h2>
          <ChartTasaExito />
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Próximos vencimientos</h2>
          <UpcomingDeadlines />
        </div>
      </div>
    </div>
  );
}
